import React from 'react'
import Covid from './components/covid';
const App = () => {
  return (
    <div>
      <Covid/>
    </div>
  )
}

export default App

